import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceProviderService } from '../../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'app-tickets-details',
  templateUrl: './tickets-details.component.html',
  styleUrl: './tickets-details.component.scss'
})
export class TicketsDetailsComponent implements OnInit {

  ticketId: any;
  ticket: any;
  comments: any[] = [];
  newComment: string = '';
  status: any;
  title: any;
  createdBy: any;

  contactMode: any;
  providerName: any;
  lastUpdated: any;
  assignedTo: any;
  createdOn: any;
  name: any;
  description: any;
  category: any;
  selectedFile: File | null = null;
  previewUrl: string | null = null;
  ticketDetails: any;
  currentStepIndex = 0;
previewVisible: boolean = false;
uploadedFileId: number | null = null;
@ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
creatorUserAccesType = -1
  userRole: number | null = null;
  activeModal: string | null = null;
  previewFileName: string | null = null;

  constructor(
    private route: ActivatedRoute, 
    private serviceProvider: ServiceProviderService,
    private router: Router,
  ) {}

  ngOnInit(): void {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    this.userRole = user.accessType;
    this.creatorUserAccesType = user.creatorUserAccessType;

    this.route.paramMap.subscribe(params => {
    this.ticketId = params.get('ticketId') || '';
    if (this.ticketId) {
      this.loadTicketDetails();
      this.loadComments();
    } else {
      console.error('ticketId not found in route');
    }
  });
  }

  loadTicketHistory(ticketId: number) {
  this.serviceProvider.getTicketHistory(ticketId).subscribe({
    next: (res) => {
      this.ticket.history = res.map(h => ({
        status: h.status,
        dateTime: h.createdOn,
        createdBy: h.createdBy, 
        isCompleted: false 
      }));
    },
    error: (err) => {
      console.error('Error loading ticket history', err);
    }
  });
}

  loadTicketDetails() {
  this.serviceProvider.getTicketsById(this.ticketId).subscribe({
    next: (res) => {
      console.log('Ticket Detail:', res);
      this.ticket = res;

      // Force attachments to be an array
      if (res.attachments && !Array.isArray(res.attachments)) {
        res.attachments = [res.attachments];
      }

      this.ticket.attachments = res.attachments;

      // Other bindings
      this.title = res.title;
      this.status = this.getStatusText(res.status);
      this.contactMode = this.getContactModeText(res.preferredContactMode);
      this.providerName = res.serviceProvider?.name;
      this.createdOn = res.createdOn;
      this.lastUpdated = res.createdOn;
      this.assignedTo = res.serviceProvider?.name;
      this.name = res.attachments?.[0]?.fileName;
      this.description = res.description;
      this.category = this.getCategoryText(res.category);

      this.loadTicketHistory(this.ticketId);
    },
    error: (err) => {
      console.error('Failed to load ticket details:', err);
    }
  });
}

  getContactModeText(preferredContactMode: any): any {
    switch (preferredContactMode) {
      case 1: return 'Phone';
      case 2: return 'Email';
      default: return 'Unknown';
    }
  }
  getStatusText(status: number): string {
    switch (status) {
      case 1: return 'Open';
      case 2: return 'In Progress';
      case 3: return 'Resolved';
      case 4: return 'Closed';
      case 5: return 'Escalated';
      default: return 'Unknown';
    }
  }

  getCategoryText(category: number): string {
  switch (category) {
    case 1: return 'Poor Service';
    case 2: return 'Billing Issue';
    case 3: return 'Application Related Issues';
    case 99: return 'Others';
    default: return 'Unknown Category';
  }
}


showPreview(file: any) {

  const fileName = file.fileName || '';
  const filePath = file.filePath;

  if (this.isPDF(fileName)) {
    window.open(filePath, '_blank');
    return;
  }

  this.previewUrl = file?.filePath;
   this.previewFileName = file?.fileName;
  this.previewVisible = true;
}

downloadFile(file: any) {
  const link = document.createElement('a');
  link.href = file.fileUrl; // make sure you have file URL here
  link.download = file.fileName;
  link.click();
}


closePreview() {
  this.previewUrl = null;
  this.previewVisible = false;
}


  loadComments() {
  this.serviceProvider.getCommentsByTicketId(this.ticketId).subscribe({
    next: (res) => {
      this.comments = res.map((item: any) => ({
        author: item.createdBy.name,
        createdAt: item.createdOn,
        text: item.comment,
        attachment: item.attachments?.[0]?.fileName || null,
        attachmentUrl: item.attachments?.[0]?.filePath || null
      }));
    },
    error: (err) => {
      console.error("Failed to load comments", err);
    }
  });
}


removeSelectedFile() {
  this.selectedFile = null;
  this.uploadedFileId = null;

  if (this.fileInput) {
    this.fileInput.nativeElement.value = '';
  }
}
previewSelectedFile(): void {
  if (!this.selectedFile) return;

  const fileUrl = URL.createObjectURL(this.selectedFile);
  this.previewUrl = fileUrl;
  this.previewVisible = true;
}


autoGrow(event: Event) {
  const textarea = event.target as HTMLTextAreaElement;
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}

onFileSelected(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files.length > 0) {
    this.selectedFile = input.files[0];

    const formData = new FormData();
    formData.append('Description', this.newComment || '');
    formData.append('File', this.selectedFile);
    formData.append('FileSourceId', '10');
    formData.append('IsPublic', 'true');

    this.serviceProvider.createFiles(formData).subscribe({
      next: (res) => {
        this.uploadedFileId = res?.fileId || null;
        console.log("File uploaded, fileId:", this.uploadedFileId);
      },
      error: (err) => console.error("Upload failed", err)
    });
  }
}



submitComment() {
    console.log('submitComment triggered');
    console.log('Comment:', this.newComment);
  console.log('uploadedFileId:', this.uploadedFileId);


    if (!this.newComment.trim() && !this.uploadedFileId) {
    console.warn('Both comment and file are empty');
    return;
  }

    const fileIdArray = this.uploadedFileId ? [this.uploadedFileId] : [];

    this.serviceProvider.postComment(this.ticketId, {
      comment: this.newComment ||"",
      fileId: fileIdArray
    }).subscribe({
      next: (res) => {
        console.log('Comment with file submitted', res);
        this.loadComments();
        this.newComment = '';
        this.uploadedFileId = null;
        this.selectedFile = null;
      },
      error: (err) => {
        console.error('Failed to submit comment', err);
      }
    });
  }



resetCommentFields() {
  this.newComment = '';
  this.selectedFile = null;
}

isImage(fileName: string): boolean {
  const ext = fileName.split('.').pop()?.toLowerCase();
  return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext || '');
}

isPDF(fileName: string): boolean {
  return fileName.toLowerCase().endsWith('.pdf');
}

openModal(type: 'resolved' | 'inProgress' | 'closed') {
  this.activeModal = type;
}

closeModal() {
  this.activeModal = null;
}

changeStatus(newStatus: number) {
  this.serviceProvider.updateStatus(this.ticketId, newStatus).subscribe({
    next: (res) => {
      if (res?.isSuccess) {
        this.ticket.status = newStatus;
        this.closeModal();
        this.router.navigate(['/support']);  
      } else {
        console.error('Status update failed:', res);
      }
    },
    error: (err) => {
      console.error('Failed to update ticket status:', err);
    }
  });
}


}
